export const getItemsByLimit = ({ collection, limit }) => {
  return collection.filter((_, index) => index < limit);
};
